module.exports = __webpack_public_path__ + "img/welcome-image@2x.6c2d0a69.jpg";